import { Column } from "src/components/tables/simpleTable";
import { EAuthserverTypeOptions, truncateText } from "src/utils";

export type AuthserverRows = Pick<
  Record<string, any>,
  "type" | "issuerURL" | "status" | "metadata" | "spec"
>;

export const useAuthserversRowsColumns = (): Column<AuthserverRows>[] => {
  return [
    {
      title: "Name",
      field: "name",
      render: ({ metadata }) => <div>{truncateText(metadata.name, 25)}</div>,
    },
    {
      title: "Type",
      field: "type",
      render: ({ spec }) => <div>{spec?.type?.toUpperCase()}</div>,
    },
    {
      title: "Client ID",
      field: "clientID",
      render: ({ spec }) => <div>{spec?.type === EAuthserverTypeOptions.oidc ? spec?.clientId : "-"}</div>,
    },
    {
      title: "Issuer’s URL",
      field: "issuerURL",
      render: ({ spec }) => (
        <div title={spec?.issuerURL?.length > 50 ? spec?.issuerURL : undefined}>
          {spec?.type === EAuthserverTypeOptions.oidc ? (
            <a href={spec.issuerURL} target="_blank" className="underline" rel="noreferrer">{truncateText(spec?.issuerURL || "", 50)}</a>
          ) : (
            <i> - </i>
          )}
        </div>
      ),
    },
  ];
};
